import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioConsultaOrdemCronologicaPagamentoMP: ['exercicio'],
    removeAdministracaoConsultaOrdemCronologicaPagamentoMP: ['administracao'],
    removeSituacaoConsultaOrdemCronologicaPagamentoMP: ['situacao'],
    removePagosConsultaOrdemCronologicaPagamentoMP: ['pagos'],
    removeNomeCredorConsultaOrdemCronologicaPagamentoMP: ['nomeCredor'],
    removeCnpjConsultaOrdemCronologicaPagamentoMP: ['cnpj'],
    removeCpfConsultaOrdemCronologicaPagamentoMP: ['cpf'],
    removeDataVencimentoInicialConsultaOrdemCronologicaPagamentoMP: ['dataVencimentoInicial'],
    removeDataVencimentoFinalConsultaOrdemCronologicaPagamentoMP: ['dataVencimentoFinal'],
    removeDataPagamentoInicialConsultaOrdemCronologicaPagamentoMP: ['dataPagamentoInicial'],
    removeDataPagamentoFinalConsultaOrdemCronologicaPagamentoMP: ['dataPagamentoFinal'],
    removeDataDocumentoInicialConsultaOrdemCronologicaPagamentoMP: ['dataDocumentoInicial'],
    removeDataDocumentoFinalConsultaOrdemCronologicaPagamentoMP: ['dataDocumentoFinal'],
    removeValorLiquidacaoInicialConsultaOrdemCronologicaPagamentoMP: ['valorLiquidacaoInicial'],
    removeValorLiquidacaoFinalConsultaOrdemCronologicaPagamentoMP: ['valorLiquidacaoFinal'],
    removeDocumentoConsultaOrdemCronologicaPagamentoMP: ['documento'],
    removeSerieDocumentoConsultaOrdemCronologicaPagamentoMP: ['serieDocumento'],
    removeRecursoConsultaOrdemCronologicaPagamentoMP: ['recurso'],
    removeDestinacaoConsultaOrdemCronologicaPagamentoMP: ['destinacao'],
    removeNumeroContratoConsultaOrdemCronologicaPagamentoMP: ['numeroContrato'],
    removeObjetoContratoConsultaOrdemCronologicaPagamentoMP: ['objetoContrato'],
    setMostraAplicarFiltroConsultaOrdemCronologicaPagamentoMP: [],
    limpaFiltroConsultaOrdemCronologicaPagamentoMP: [],
    aplicarFiltroConsultaOrdemCronologicaPagamentoMP: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    administracao: [],
    situacao: [],
    pagos: '',
    nomeCredor: '',
    cnpj: '',
    cpf: '',
    dataVencimentoInicial: '',
    dataVencimentoFinal: '',
    dataPagamentoInicial: '',
    dataPagamentoFinal: '',
    dataDocumentoInicial: '',
    dataDocumentoFinal: '',
    valorLiquidacaoInicial: '',
    valorLiquidacaoFinal: '',
    documento: '',
    serieDocumento: '',
    recurso: [],
    destinacao: [],
    numeroContrato: '',
    objetoContrato: '',
    mostraAplicarFiltro: false,
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeSituacao = (state = INITIAL_STATE, action) => {
    state.situacao.splice(state.situacao.indexOf(action.situacao), 1)
    state.situacao = Array.from(state.situacao)
    return { ...state, mostraAplicarFiltro: true }
}

const removePagos = (state = INITIAL_STATE, action) => {
    return { ...state, pagos: '', mostraAplicarFiltro: true }
}
const removeNomeCredor = (state = INITIAL_STATE, action) => {
    return { ...state, nomeCredor: '', mostraAplicarFiltro: true }
}
const removeCnpj = (state = INITIAL_STATE, action) => {
    return { ...state, cnpj: '', mostraAplicarFiltro: true }
}
const removeCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: '', mostraAplicarFiltro: true }
}
const removeDataVencimentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataVencimentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataVencimentoFinal: '', mostraAplicarFiltro: true }
}
const removeDataPagamentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataPagamentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataPagamentoFinal: '', mostraAplicarFiltro: true }
}
const removeDataDocumentoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataDocumentoInicial: '', mostraAplicarFiltro: true }
}
const removeDataDocumentoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataDocumentoFinal: '', mostraAplicarFiltro: true }
}
const removeValorLiquidacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, valorLiquidacaoInicial: '', mostraAplicarFiltro: true }
}
const removeValorLiquidacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, valorLiquidacaoFinal: '', mostraAplicarFiltro: true }
}
const removeDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, documento: '', mostraAplicarFiltro: true }
}
const removeSerieDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, serieDocumento: '', mostraAplicarFiltro: true }
}
const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recurso.splice(state.recurso.indexOf(action.recurso), 1)
    state.recurso = Array.from(state.recurso)
    return { ...state, mostraAplicarFiltro: true }
}
const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacao.splice(state.destinacao.indexOf(action.destinacao), 1)
    state.destinacao = Array.from(state.destinacao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeNumeroContrato = (state = INITIAL_STATE, action) => {
    return { ...state, numeroContrato: '', mostraAplicarFiltro: true }
}
const removeObjetoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, objetoContrato: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeExercicio,
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeAdministracao,
    [Types.REMOVE_SITUACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeSituacao,
    [Types.REMOVE_PAGOS_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removePagos,
    [Types.REMOVE_NOME_CREDOR_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeNomeCredor,
    [Types.REMOVE_CNPJ_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeCnpj,
    [Types.REMOVE_CPF_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeCpf,
    [Types.REMOVE_DATA_VENCIMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeDataVencimentoInicial,
    [Types.REMOVE_DATA_VENCIMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeDataVencimentoFinal,
    [Types.REMOVE_DATA_PAGAMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeDataPagamentoInicial,
    [Types.REMOVE_DATA_PAGAMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeDataPagamentoFinal,
    [Types.REMOVE_DATA_DOCUMENTO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeDataDocumentoInicial,
    [Types.REMOVE_DATA_DOCUMENTO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeDataDocumentoFinal,
    [Types.REMOVE_VALOR_LIQUIDACAO_INICIAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeValorLiquidacaoInicial,
    [Types.REMOVE_VALOR_LIQUIDACAO_FINAL_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeValorLiquidacaoFinal,
    [Types.REMOVE_DOCUMENTO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeDocumento,
    [Types.REMOVE_SERIE_DOCUMENTO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeSerieDocumento,
    [Types.REMOVE_RECURSO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeRecurso,
    [Types.REMOVE_DESTINACAO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeDestinacao,
    [Types.REMOVE_NUMERO_CONTRATO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeNumeroContrato,
    [Types.REMOVE_OBJETO_CONTRATO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: removeObjetoContrato,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_MP]: aplicarFiltro,
})
